var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "direction",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3847",
    "data-name": "Rectangle 3847",
    width: 20,
    height: 20,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27583",
    "data-name": "Path 27583",
    d: "M14.867,12.259h0a.723.723,0,0,1-.726-.726V7.475l-7.9,7.9a.723.723,0,0,1-1.023,0h0a.723.723,0,0,1,0-1.023l7.9-7.9H9.06a.728.728,0,0,1-.726-.726h0A.728.728,0,0,1,9.06,5h5.807a.728.728,0,0,1,.726.726v5.807A.728.728,0,0,1,14.867,12.259Z",
    transform: "translate(-0.592)",
    fill: "#19bc9c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirection);
export default __webpack_public_path__ + "static/media/direction.e0ebfaacbcf19790891b28d655819a64.svg";
export { ForwardRef as ReactComponent };